import React, { useState, useRef, useEffect } from "react";
import { Shield, ShieldAlert, X } from "lucide-react";
import OtpIcon from "../../assets/icons/admin-customer-icons/otp-icon";
import ClockIcon from "../../assets/icons/admin-customer-icons/clock-Icon";
import { url } from "../../redux/config";
import axios from "axios";
import errorToast from "../helper-components/error-toast";
import LoadingOverlay from "../helper-components/overlay-loading";
import successToast from "../helper-components/success-toast";

const VerificationPopup = ({
  setPopUp,
  tokenExpiresIn,
  txnId,
  accessToken,
  setABHAverified,
}) => {
  const [code, setCode] = useState(["", "", "", "", "", ""]);
  const [timeLeft, setTimeLeft] = useState(tokenExpiresIn || 1800); // 2:00 in seconds
  const [isOpen, setIsOpen] = useState(true);
  const inputRefs = useRef([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins.toString().padStart(2, "0")}:${secs
      .toString()
      .padStart(2, "0")}`;
  };
  useEffect(() => {
    // Use setTimeout to ensure the input is rendered and available
    const focusTimeout = setTimeout(() => {
      if (inputRefs.current[0]) {
        inputRefs.current[0].focus();
      }
    }, 100); // Small delay to ensure DOM is ready

    return () => clearTimeout(focusTimeout);
  }, [isOpen]);
  const handleInputChange = (index, value) => {
    if (value.length > 1) return;

    const newCode = [...code];
    newCode[index] = value;
    setCode(newCode);

    // Auto-focus next input
    if (value && index < 5) {
      inputRefs.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (index, e) => {
    // Handle backspace
    if (e.key === "Backspace" && !code[index] && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
  };
  const validateOtpWithAadhaar = async (otp) => {
    try {
      const response = await axios.post(
        `${url}/abha-integration/verify-login-otp-via-abha-number`,
        {
          txnId: txnId,
          accessToken: accessToken,
          otp: otp,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      console.log("Response:", response.data);
      setLoading(false);
      setPopUp(false);
      if (
        response?.data?.data?.abdmResponse?.message ===
        "OTP verified successfully"
      ) {
        successToast("Verified");
        setABHAverified(true);
      } else {
        errorToast(response?.data?.data?.abdmResponse?.authResult);
      }
      return response.data;
    } catch (error) {
      errorToast(error.response?.data || error.message);
      console.error(
        "Error sending OTP:",
        error.response?.data || error.message
      );
      setLoading(false);
      // throw error;
    }
  };
  const handleVerifyCode = () => {
    const enteredCode = code.join("");
    if (enteredCode.length === 6) {
      validateOtpWithAadhaar(enteredCode);
    }
  };

  const handleResendOTP = () => {
    setCode(["", "", "", "", "", ""]);
    setTimeLeft(120);
    alert("OTP has been resent to your registered mobile number");
  };

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 flex items-center justify-center bg-[rgba(0,0,0,0.7)]
 backdrop-blur-sm z-[2000] w-auto"
    >
      <LoadingOverlay isLoading={loading} />

      <div className="bg-white rounded-2xl shadow-xl w-96 p-6 relative">
        {/* Close button */}
        <button
          onClick={() => setPopUp(false)}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600"
        >
          <X size={20} />
        </button>

        {/* Header */}
        <div className="text-center mb-6">
          <div className="w-12 h-12 bg-[var(--primary-button-bg-color)] rounded-full flex items-center justify-center mx-auto mb-4">
            <OtpIcon />
          </div>
          <div className="text-center flex flex-col gap-2">
            <h2 className="  font-[var(--customer-current-nav-fw)] text-[length:var(--customer-pop-up-fs)] mb-2">
              Enter Verification Code
            </h2>
            <p className=" font-[var(--customer-nav-fw)] text-[length:var(--customer-info-fs)] text-[var(--customer-read-fg)]">
              We've sent a 6-digit verification code to your registered mobile
              number
            </p>
          </div>
        </div>

        {/* OTP Input Section */}
        <div className="mb-6">
          <label className="block font-[var(--customer-nav-fw)] text-[length:var(--customer-info-fs)] mb-3">
            Enter OTP
          </label>
          <div className="flex justify-between mb-4">
            {code.map((digit, index) => (
              <input
                key={index}
                ref={(el) => (inputRefs.current[index] = el)}
                type="text"
                maxLength="1"
                value={digit}
                onChange={(e) => handleInputChange(index, e.target.value)}
                onKeyDown={(e) => handleKeyDown(index, e)}
                className="w-12 h-12 text-center text-lg font-semibold border-2 border-[var(--customer-business-border)] rounded-lg focus:border-blue-500 focus:outline-none transition-colors"
                placeholder=""
              />
            ))}
          </div>
        </div>

        {/* Verify Button */}
        <button
          onClick={handleVerifyCode}
          disabled={code.join("").length !== 6}
          className={`w-full ${
            code.join("").length !== 6
              ? "bg-[var(--customer-verify-disabled-bg)] disabled:cursor-not-allowed"
              : "bg-[var(--primary-button-bg-color)]"
          }  text-white font-medium py-3 px-4 rounded-lg  mb-4`}
        >
          Verify Code
        </button>
        {/* hover:bg-blue-600 disabled:bg-blue-300  */}
        {/* Resend Section */}
        <div className="text-center">
          {/* <p className="text-gray-600 text-sm mb-2">Didn't receive the code?</p>
          <button
            onClick={handleResendOTP}
            className="text-green-500 hover:text-green-600 font-medium text-sm transition-colors"
          >
            Resend OTP
          </button> */}

          {/* Timer */}
          <div className="flex items-center justify-center mt-3 gap-1 text-gray-500 text-sm">
            {/* <span className="mr-1">🕐</span> */}
            <ClockIcon />
            <span>Code expires in {formatTime(timeLeft)}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VerificationPopup;
